import { Tooltip } from 'antd';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import styled from 'styled-components';
import Link from 'next/link';
import React from 'react';
import { HSMSCalendarProps } from '@modules/timetable';

const localizer = momentLocalizer(moment);

const EventWrapper = styled.div`
  border-radius: 4px;

  .rbc-event {
    align-items: center !important;
    background-color: ${({ color }) => color} !important;
  }

  .rbc-event-label {
    font-size: 0.9rem;
  }
`;

const CalenderItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const HSMSCalendarWrapper = styled.div`
  .rbc-calendar {
    min-height: 650px;
  }
`;

export const HSMSCalendar = ({ timetableCalendarItems, userId }: HSMSCalendarProps) => {
  return (
    <HSMSCalendarWrapper>
      <Calendar
        localizer={localizer}
        defaultView="month"
        events={timetableCalendarItems}
        tooltipAccessor={() => ''}
        components={{
          eventWrapper: ({ event, children }) => <EventWrapper color={event.color || '#000'}>{children}</EventWrapper>,
          event: (event) =>
            userId ? (
              <Link
                href="/lecture/[timetableItemId]/attendance/"
                as={`/lecture/${event.event.timetableItemId}/attendance/`}
              >
                <Tooltip
                  placement="right"
                  title={() => (
                    <div>
                      <p>
                        <strong>Subject: </strong>
                        {event.event.subject}
                      </p>
                      <p>
                        <strong>Batch: </strong>
                        {event.event.batch}
                      </p>
                      {event.event?.class && (
                        <p>
                          <strong>Class: </strong>
                          {event.event.class}
                        </p>
                      )}
                      <p>
                        <strong>Location: </strong>
                        {event.event.location}
                      </p>
                    </div>
                  )}
                >
                  <CalenderItemContainer>
                    <strong>{event.title}</strong>
                  </CalenderItemContainer>
                </Tooltip>
              </Link>
            ) : (
              <Tooltip
                placement="right"
                title={() => (
                  <div>
                    <p>
                      <strong>Subject: </strong>
                      {event.event.subject}
                    </p>
                    <p>
                      <strong>Batch: </strong>
                      {event.event.batch}
                    </p>
                    <p>
                      <strong>Location: </strong>
                      {event.event.location}
                    </p>
                    <p>
                      <strong>Lecturer: </strong>
                      {event.event.lecturer}
                    </p>
                  </div>
                )}
              >
                <CalenderItemContainer>
                  <strong>{event.title}</strong>
                </CalenderItemContainer>
              </Tooltip>
            ),
        }}
      />
    </HSMSCalendarWrapper>
  );
};
